import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDataDatetime = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.42345 18.4167C4.00248 18.4167 3.64616 18.2708 3.35449 17.9792C3.06283 17.6875 2.91699 17.3312 2.91699 16.9102V5.75647C2.91699 5.3355 3.06283 4.97918 3.35449 4.68751C3.64616 4.39585 4.00248 4.25001 4.42345 4.25001H5.5772V2.4873H6.85928V4.25001H13.1735V2.4873H14.4235V4.25001H15.5772C15.9982 4.25001 16.3545 4.39585 16.6462 4.68751C16.9378 4.97918 17.0837 5.3355 17.0837 5.75647V16.9102C17.0837 17.3312 16.9378 17.6875 16.6462 17.9792C16.3545 18.2708 15.9982 18.4167 15.5772 18.4167H4.42345ZM4.42345 17.1667H15.5772C15.6414 17.1667 15.7001 17.1399 15.7535 17.0865C15.8069 17.0331 15.8337 16.9744 15.8337 16.9102V9.0898H4.16699V16.9102C4.16699 16.9744 4.19373 17.0331 4.2472 17.0865C4.30053 17.1399 4.35928 17.1667 4.42345 17.1667ZM4.16699 7.8398H15.8337V5.75647C15.8337 5.6923 15.8069 5.63355 15.7535 5.58022C15.7001 5.52675 15.6414 5.50001 15.5772 5.50001H4.42345C4.35928 5.50001 4.30053 5.52675 4.2472 5.58022C4.19373 5.63355 4.16699 5.6923 4.16699 5.75647V7.8398Z",
		fill: "currentColor"
	})
});
export default SvgDataDatetime;
